export default "__VITE_ASSET__e273b63a__"